var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoundCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#fffbeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 90,
    width: 180,
    height: 70,
    rx: 18,
    fill: "white",
    stroke: "#d97706",
    strokeWidth: 2.5,
    transform: "rotate(-12 200 125)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 100,
    width: 60,
    height: 50,
    rx: 8,
    fill: "#fef3c7",
    transform: "rotate(-12 200 125)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 123,
    r: 3,
    fill: "#d97706",
    opacity: 0.2,
    transform: "rotate(-12 200 125)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 3,
    fill: "#d97706",
    opacity: 0.2,
    transform: "rotate(-12 200 125)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 123,
    r: 3,
    fill: "#d97706",
    opacity: 0.2,
    transform: "rotate(-12 200 125)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 192,
    width: 34,
    height: 12,
    rx: 3.5,
    fill: "#d97706",
    opacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 182,
    width: 14,
    height: 32,
    rx: 3.5,
    fill: "#d97706",
    opacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 262,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#92400e"
  }, "Yara Bakimi")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoundCare);
export default __webpack_public_path__ + "static/media/wound-care.a542680283e1c9871f4403db56877438.svg";
export { ForwardRef as ReactComponent };